import { Component, Directive, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FeedbackQuestionSurvey } from '../providers/question-provider';

import { FeedbackQuestionService } from './feedback-question.service';
import { Subscription } from 'rxjs';
import { Feedback } from "../../common/models/feedback";


@Directive()
export abstract class BaseQuestion implements OnDestroy {
    public type: any;
    public answerReceived: EventEmitter<void> = new EventEmitter();
    public answerRemoved: EventEmitter<void> = new EventEmitter();
    public nextQuestionClicked: EventEmitter<any> = new EventEmitter();
    public previousQuestionClicked: EventEmitter<any> = new EventEmitter();

    public isSubmitting = false;

    @Output()
    public onAnswerChange: EventEmitter<any> = new EventEmitter();

    private _feedback: Feedback = {} as Feedback;
    private _question: FeedbackQuestionSurvey = {} as FeedbackQuestionSurvey;
    private _previousAnswers: any = null;
    private _answeredAnswers: any = null;
    private _hasAnsweredQuestion = false;

    private backSubscription: Subscription;

    protected constructor(
        private feedbackQuestionService: FeedbackQuestionService
    ) {
        this.backSubscription = feedbackQuestionService.backClicked.subscribe((question) => {
            this._previousAnswers = null;

            this.previousQuestionClicked.emit({question});
        });
    }

    public ngOnDestroy(): void {
        this.backSubscription.unsubscribe();
    }

    set feedback(feedback: Feedback) {
        this._feedback = feedback;
    }

    get feedback(): Feedback {
        return this._feedback;
    }

    set question(question: FeedbackQuestionSurvey) {
        this._question = question;
    }

    get question(): FeedbackQuestionSurvey {
        return this._question;
    }

    set previousAnswers(answers: any) {
        this._previousAnswers = answers;
    }

    get previousAnswers(): any {
        return this._previousAnswers;
    }

    set answeredAnswers(answers: any) {
        this._answeredAnswers = answers;
    }

    get answeredAnswers(): any {
        return this._answeredAnswers;
    }

    set hasAnsweredQuestion(yesOrNo: boolean) {
        this._hasAnsweredQuestion = yesOrNo;
    }

    get hasAnsweredQuestion(): boolean {
        return this._hasAnsweredQuestion;
    }

    public answerChanged(event: any): void {
        if (event === null) {
            this.answerRemoved.emit();

            return;
        }

        this.answerReceived.emit(event);
    }

    public onNextQuestionClicked(event: any): void {
        this.nextQuestionClicked.emit({question: this._question, answers: event.answers, isBack: event.isBack});
    }

    public onPreviousQuestionClicked(event: any): void {
        this.previousQuestionClicked.emit({question: this._question});
    }
}

export default BaseQuestion;
